module.exports = __webpack_public_path__ + "img/38.00b48b37.jpg";